module.exports = __webpack_public_path__ + "static/media/pocket_square_red.97325656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pocket_square_red.png
// module id = 127
// module chunks = 0